import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/answerCase1.png'
import _imports_1 from '../../../assets/answerCase2.png'
import _imports_2 from '../../../assets/answerCase3.png'
import _imports_3 from '../../../assets/answerCase4.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-562c80b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "addScoringResultForm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "查看案例", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "案例", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"600px"}
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"600px"}
}, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"600px"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"width":"600px"}
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "resultTable" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "评分结果管理", -1))

import { ref, watchEffect } from "vue";
import API from "@/api";
import {
  addScoringResultUsingPost,
  deleteScoringResultUsingPost,
  editScoringResultUsingPost,
  listMyScoringResultVoByPageUsingPost,
} from "@/api/scoringResultController";
import message from "@arco-design/web-vue/es/message";
import dayjs from "dayjs";
import { useRouter } from "vue-router";
import { APP_TYPE_ENUM } from "@/constant/appEnum";
import { getAppVoByIdUsingGet } from "@/api/appController";
import PictureUpload from "@/components/picture/PictureUpload.vue";

interface Props {
  appId: number;
}

//

export default /*#__PURE__*/_defineComponent({
  __name: 'addScoringResultPage',
  props: {
    appId: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
// 添加表单或修改
const form = ref<API.ScoringResultAddRequest>({});
//要更新的Id
const updateId = ref<number>(0);

//传递参数
const searchParams = ref<API.ScoringResultQueryRequest>({
  appId: props.appId,
  current: 1,
  pageSize: 10,
  sortField: "createTime",
  sortOrder: "descend",
});
//数据
const dataList = ref<API.ScoringResultVO[]>([]);
//总值
const total = ref<number>(0);
//应用数据
const app = ref<API.AppVO>({});
const visible = ref(false);
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  //获取应用信息
  const appRes = await getAppVoByIdUsingGet({
    id: props.appId,
  });
  if (appRes.data.code === 0 && appRes.data.data) {
    app.value = appRes.data.data;
  } else {
    message.error("获取应用信息失败，" + appRes.data.message);
  }
  const response = await listMyScoringResultVoByPageUsingPost(
    searchParams.value
  );
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};
/**
 * 搜索
 */
const search = () => {
  loadData();
};
/**
 * 创建或编辑评分结果
 */
const submitScoringResult = async () => {
  if (props.appId === 0 || !props.appId) {
    message.error("appId不存在，请重新先选择应用");
    return;
  }
  let response: any;
  //有就是修改
  if (updateId.value) {
    response = await editScoringResultUsingPost({
      ...form.value,
      id: updateId.value as any,
    });
    //有就是修改
  } else {
    response = await addScoringResultUsingPost({
      ...form.value,
      appId: props.appId as any,
    });
  }
  if (response.data.code === 0) {
    message.success("操作成功!");
    form.value = {};
    loadData();
  } else {
    message.error("操作失败，" + response.data.message);
  }
  updateId.value = undefined;
};

/**
 * 更新
 */
const doUpdate = (scoringResult: API.ScoringResultVO) => {
  updateId.value = scoringResult.id;
  form.value = scoringResult;
};
/**
 * 更新
 */
const cancelUpdate = () => {
  updateId.value = 0;
  form.value = {};
};

/**
 * 删除
 */
const doDelete = async (id: number) => {
  const res = await deleteScoringResultUsingPost({ id });
  if (res.data.code === 0) {
    loadData();
  } else {
    message.error("删除失败，" + res.data.message);
  }
};

const columns = [
  {
    title: "结果名称",
    dataIndex: "resultName",
  },
  {
    title: "结果描述",
    dataIndex: "resultDesc",
  },
  {
    title: "结果图片",
    dataIndex: "resultPicture",
    slotName: "resultPicture",
  },
  {
    title: "结果属性",
    dataIndex: "resultProp",
  },
  {
    title: "结果分数范围",
    dataIndex: "resultScoreRange",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    slotName: "createTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, "评分结果" + _toDisplayString(updateId.value == 0 ? "创建" : "修改"), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_a_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_modal, {
              visible: visible.value,
              "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
              width: "700px",
              footer: false
            }, {
              title: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                (app.value.appType === _unref(APP_TYPE_ENUM).TEST)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ]),
        _: 1
      }),
      _hoisted_12,
      _createVNode(_component_a_form, {
        model: form.value,
        style: { width: '400px' },
        "label-align": "left",
        "auto-label-width": "",
        onSubmit: submitScoringResult
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "应用 ID " }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.appId), 1)
            ]),
            _: 1
          }),
          (updateId.value != 0)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                label: "修改的结果 ID "
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(updateId.value) + " ", 1),
                      _createVNode(_component_a_button, {
                        type: "text",
                        onClick: cancelUpdate
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("取消")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (updateId.value)
            ? (_openBlock(), _createBlock(_component_a_space, {
                key: 1,
                label: "",
                size: "large"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            label: "评分结果名称",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: form.value.resultName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.resultName) = $event)),
                placeholder: "请输结果名称...",
                "allow-clear": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "结果描述" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: form.value.resultDesc,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.resultDesc) = $event)),
                placeholder: "请输入结果描述...",
                "allow-clear": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "评分结果图标",
            tooltip: "输入图标链接"
          }, {
            default: _withCtx(() => [
              _createVNode(PictureUpload, {
                biz: "result_picture",
                value: form.value.picture,
                onChange: (url) => (form.value.picture = url)
              }, null, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          (app.value.appType === _unref(APP_TYPE_ENUM).TEST)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 2,
                label: "评分结果集",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_tag, {
                    modelValue: form.value.resultProp,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.resultProp) = $event)),
                    placeholder: "请输结果结果集（按回车即可）",
                    "allow-clear": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (app.value.appType === _unref(APP_TYPE_ENUM).SCORE)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 3,
                label: "结果得分范围",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    modelValue: form.value.resultScoreRange,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.resultScoreRange) = $event)),
                    placeholder: "请输结果得分范围...",
                    "allow-clear": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_button, {
            type: "primary",
            "html-type": "submit",
            style: {"width":"100px","margin":"0 auto 10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(updateId.value == 0 ? "创建" : "修改") + "评分结果 ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createVNode(_component_a_form, {
        layout: "inline",
        style: {"margin":"0 0 10px auto"},
        "label-align": "left",
        "auto-label-width": "",
        onSubmit: search
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            field: "resultName",
            label: "结果名："
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: searchParams.value.resultName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchParams.value.resultName) = $event)),
                placeholder: "请输入...",
                "allow-clear": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            field: "resultDesc",
            label: "结果描述："
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: searchParams.value.resultDesc,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((searchParams.value.resultDesc) = $event)),
                placeholder: "请输入...",
                "allow-clear": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                style: {"width":"120px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_table, {
        columns: columns,
        data: dataList.value,
        pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
        stripe: true,
        bordered: { cell: true },
        onPageChange: onPageChange
      }, {
        resultPicture: _withCtx(({ record }) => [
          _createVNode(_component_a_image, {
            width: "64",
            src: record.resultPicture
          }, null, 8, ["src"])
        ]),
        createTime: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD")), 1)
        ]),
        optional: _withCtx(({ record }) => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: ($event: any) => (doUpdate(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("修改")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_popconfirm, {
                content: "确定要删除吗",
                onOk: ($event: any) => (doDelete(record.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { status: "danger" }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onOk"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data", "pagination"])
    ])
  ], 64))
}
}

})